module.exports = __webpack_public_path__ + "static/media/logo-salato.9e0bf3c6.png";